/**
 * Подставляет группу этапа из справочника, если API не вернул вложенный stage.
 */
export function enrichScheduleStageMeta(schedules, stages = []) {
  if (!stages.length) return schedules;

  const byId = new Map(stages.map((s) => [s.id, s]));
  const byName = new Map(stages.map((s) => [s.name, s]));

  return schedules.map((row) => {
    const hasGroup =
      row.stage_group_name ||
      row.stage?.stage_group?.name;
    if (hasGroup) return row;

    const stage =
      (row.construction_stage_id && byId.get(row.construction_stage_id)) ||
      (row.construction_stage && byName.get(row.construction_stage));

    if (!stage?.stage_group) return row;

    return {
      ...row,
      stage_group_name: stage.stage_group.name,
      stage: row.stage?.stage_group ? row.stage : stage,
    };
  });
}
